import { Form } from "../Support/Form";
import { axios } from "../Support/axios";

export class Token extends Form {

    constructor(data = {}) {
        super(data);

        this.result = false;
    }

    index(append = false) {
        let self = this;

        return new Promise((resolve, reject) => {
            let uri = '/api/token?page=' + self.page;

            axios.get(uri).then(response => {
                let result = response.data;

                self.processIndexData(result, append);

                resolve(result);
            }).catch(error => {
                self.setError(error);

                reject(error);
            });
        });
    }

    create() {
        let self = this;

        self.resetFormMessages().then(result => {
            self.setFormUpdating();
        });

        return new Promise((resolve, reject) => {
            axios.post('/api/token', self.data).then(response => {

                self.result = response.data.data;

                self.setFormUpdateComplete();

                resolve(response);
            }).catch(error => {
                self.setError(error);

                reject(error);
            });
        });
    }

    deleteToken(id) {
        let self = this;

        self.resetFormMessages().then(result => {
            self.setFormUpdating();
        });

        return new Promise((resolve, reject) => {
            axios.delete('/api/token/' + id, self.data).then(response => {

                self.setFormUpdateComplete();

                resolve(response);
            }).catch(error => {
                self.setError(error);

                reject(error);
            });
        });
    }

}
